<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
	<p>{{ data.body }}</p>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="onAllowClick()" cdkFocusInitial>{{ data.btnConfirm ? data.btnConfirm : 'Ok' }}</button>
	<button mat-button (click)="onNoClick()">{{ data.btnCancel ? data.btnCancel : 'Cancel' }}</button>
</div>
